import type { Product, SelectedBundleOptionValue } from "@jti/magento";

import type { SummaryItem } from "../../ItemsSummaryView";
import { getDiscountedPrice } from "../getDiscountedPrice";

type SelectedBundleOptionValueWithLabel = SelectedBundleOptionValue & { label?: string };

export const mapBundleProductToSummaryItem = (
  cartItem: Product,
  displayBundleSelectedItems: boolean,
  displayBundleSelectedItemsPrices: boolean,
  showPricesWithTaxExcluded: boolean = false
): SummaryItem => {
  const currency = cartItem.prices?.row_total_including_tax.currency ?? "";

  const subItems =
    cartItem.bundle_options?.flatMap(
      (option) =>
        option.values?.map((value: SelectedBundleOptionValueWithLabel) => ({
          thumbnail: {
            src: value.presentation_info.product.small_image.url,
            alt: value.presentation_info.product.small_image.label,
          },
          quantity: value.quantity,
          title: `${option.label}${value.label ? `: ${value.label}` : ""}`,
          basePrice: {
            value: cartItem.isGift ? 0 : value.presentation_info.initial_price,
            currency,
          },
          discountedPrice: cartItem.isGift ? undefined : getDiscountedPrice(value, currency),
        })) ?? []
    ) ?? [];

  const priceToUse = showPricesWithTaxExcluded ? cartItem.prices?.row_total : cartItem.prices?.row_total_including_tax;

  const badge = cartItem.isGift ? "cart.payment_summary.freeGift" : undefined;

  return {
    type: "bundle",
    id: cartItem.id ?? cartItem.sku,
    item: {
      title: cartItem.name,
      badge: badge,
      thumbnail: { src: cartItem.imageUrl, alt: cartItem.name ?? "" },
      subtitle: cartItem.subtitle,
      quantity: cartItem.quantity,
      price: {
        value: priceToUse?.value ?? 0,
        currency: priceToUse?.currency ?? "",
      },
      subItems: subItems ?? [],
      areBundleItemsShown: displayBundleSelectedItems,
      areBundlePricesEnabled: displayBundleSelectedItemsPrices,
    },
  };
};
